<template>
  <div class="l-row" style="margin-left: 0px;">
    <loader :loading="loading"/>
    <form-group :label="`${$t('category.label')} ${$t('level.label')} ${(i + 1)}`" :columns="4" v-for="(categoriesLevel, i) in categories">
      <select class="form-select" v-model="selectedCategory[i]" @change="loadChildrenCategory(i)">
        <option v-for="category in categoriesLevel" :key="category" :value="category.id">{{ category.name }}</option>
      </select>
    </form-group>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import api from '@/api'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      loading: true,
      selectedCategory: [],
      categories: [],
      currentLevel: 0
    }),
    async mounted () {
      try {
        const accountId = await api.mercadoLivre.getActiveAccountId()
        this.categories.push(await api.mercadoLivre.getCategories(accountId))
      } catch (err) {
        notifier.error('Impossível carregar as categorias do Mercado Livre.', 'Erro')
      }

      this.loading = false
    },
    methods: {
      async loadChildrenCategory (index) {
        this.loading = true

        if (index < this.currentLevel) {
          var prevCategories = []
          this.categories.forEach((categoryLevel, j) => {
            if (j <= index) {
              prevCategories.push(categoryLevel)
            } else {
              if (this.selectedCategory[j] !== undefined) {
                delete this.selectedCategory[j]
              }
            }
          })
          this.categories = prevCategories
        }

        this.currentLevel = index
        this.$emit('selectedCategory', this.selectedCategory[index])

        try {
          const accountId = await api.mercadoLivre.getActiveAccountId()
          this.categories.push(await api.mercadoLivre.getCategories(accountId, this.selectedCategory[index]))
          this.loading = false
        } catch (err) {
          this.loading = false
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      Panel,
      FormGroup,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Category.vue?565a2f73